import { all, fork } from 'redux-saga/effects';

import watchCallMeRequest from './callMeRequest';

function* cartSagas() {
  yield all([fork(watchCallMeRequest)]);
}

export default cartSagas;
